import {register} from '@shopify/theme-sections';
import Swiper from 'swiper';

const selectors = {
  target: '.reviews__slider--',
};

register('reviews', {
  onLoad() {
    this.init();
  },

  init() {
    this.cleanSlide(this.id);
  },

  cleanSlide(id) {
    const target = `${selectors.target}${id}`;
    const targetSelector = document.querySelector(target);

    if (!targetSelector) { return; }

    const desktopItemCount = targetSelector.dataset.desktopItemRow;

    const swiper = new Swiper(target, {
      slidesPerView: 1,
      loop: true,
      freeMode: false,
      navigation: {
        nextEl: `.swiper-button-next--${id}`,
        prevEl: `.swiper-button-prev--${id}`,
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: 'true',
      },
      breakpoints: {
        // when window width is >= 790px
        790: {
          slidesPerView: desktopItemCount,
        }
      }
    });
  },

  onBlockSelect: (blockId) => {
    const id = blockId.detail.sectionId;
    const currentSlide = parseInt(blockId.target.dataset.swiperSlideIndex) + 1;
    const target = `${selectors.target}${id}`;
    const swiper = document.querySelector(target).swiper;
    swiper.slideTo(currentSlide, 1000, false);

    console.log(`🤠 Slide to block ${currentSlide}`)
  },
});
